import React from 'react'
import styled from 'styled-components'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import {KeyboardArrowDown, KeyboardArrowRight} from '@mui/icons-material'
import {Link} from 'react-router-dom'
import {getEntitiesIcons, debounce} from 'utils/utils'

const Container = styled.div`
    display: flex;
    align-items: center;
    margin-right: auto;
    flex-wrap: wrap;

    > a:first-child {
        color: #A0B7BE;
        font-size: 16px;
        cursor: pointer;
        font-weight: normal;
    }

    > div, a {
        font-weight: bold;
        font-size: 20px;
        color: #4a4a4a;
        white-space: nowrap;
        display: flex;
    }
`

const Input = styled.div`
    position: relative;

    div:not(:first-child) {
        left: 0;
        right: 0;
        bottom: -5px;
        content: "";
        position: absolute;
        transform: scaleX(0);
        transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
        border-bottom: 2px solid #415dd4;
        pointer-events: none;
    }

    svg {
        display: block;
    }

    div:first-child:focus {
        + div {
            transform: scaleX(1);
        }

        ~ svg {
            display: none;
        }
    }
`

const ArrowDown = styled(KeyboardArrowDown)`
    font-size: 22px;
    cursor: pointer;
    align-self: flex-end;
    margin-seft: 3px;
`

const ArrowRight = styled(KeyboardArrowRight)`
    font-size: 22;
    color: #A0B7BE;
`

const Search = styled(TextField)`
	width: auto;
	padding: 10px;
	position: sticky;
	top: 0;
	background: #FFFFFF;
	z-index: 1;
	display: flex;
`

class Navigation extends React.Component {
    constructor(props) {
        super(props)

		this.entities = []
		
        this.state = {
            anchorEl: null,
			pattern: ''
        }
    }

    handleClick = event => {
		if (this.props.entities) {
			this.entities = getEntitiesIcons()
		}

        this.setState({ anchorEl: event.currentTarget })
    }

	handleChange = debounce((value) => {
        this.entities = getEntitiesIcons(value)
        this.setState({ pattern: value })
    }, 300)

    handleClose = () => {
		this.entities = []
        this.setState({ anchorEl: null, pattern: '' })
    }

    handleCheckKeyCode = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault()
            this.title.blur()
        }

        if (e.keyCode === 27) {
            this.title.blur()
        }
    }

    handleBlur = (e) => {
        if (e.target.innerText) {
            if (e.target.innerText !== this.props.table) {
                this.props.fetchRenameEntity(e.target.innerText, this.props.tableId)
            }
        } else {
            this.title.innerText = this.props.table
        }
    }

    render() {
        return (
            <Container>
                <Link to={'/'}>{this.props.application}</Link>
                <ArrowRight />
                {this.props.recordId ?
                    <React.Fragment>
                        <Link to={`/table/${this.props.tableId}`}>{this.props.table}</Link>
                        <ArrowRight />
                        <Link to={`/record/${this.props.tableId}/${this.props.recordId}`}>{this.props.record}</Link>
                    </React.Fragment>
                    :
                    <Input>
                        <div
                            ref={el => this.title = el}
                            contentEditable={this.props.permissions.Designer ? true : false}
                            spellCheck={false}
                            suppressContentEditableWarning={true}
                            onBlur={this.handleBlur}
                            onKeyDown={this.handleCheckKeyCode}
                            style={{minWidth: '15px'}}
                        >
                            {this.props.table}
                        </div>
                        <div />
                        <ArrowDown onClick={this.handleClick}
                        />
                    </Input>
                }
                {this.props.relation &&
                    <React.Fragment>
                        <ArrowRight />
                        <div>
                            {this.props.relation}
                            {this.props.relations.length > 1 &&
                                <ArrowDown onClick={this.handleClick} />
                            }
                        </div>
                    </React.Fragment>
                }
                {this.props.relations && this.props.relations.length > 1 &&
                    <Menu
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: '300px',
                                maxWidth: '500px'
                            }
                        }}
                    >
                        {this.props.relations.map((item, index) =>
                            <Link key={index} to={`/relation/${item.id}/${this.props.recordId}`} onClick={this.handleClose}>
                                <MenuItem selected={item.id === this.props.relationId}>
                                    <Typography variant='inherit' noWrap>
                                        {item.name}
                                    </Typography>
                                </MenuItem>
                            </Link>
                        )}
                    </Menu>
                }
                {this.props.entities &&
                    <Menu
                        anchorEl={this.state.anchorEl}
                        open={!!this.state.anchorEl}
                        onClose={this.handleClose}
						variant='menu'
						MenuListProps={{
                            style: {
                                paddingTop: 0
                            }
                        }}
                        PaperProps={{
                            style: {
                                maxHeight: '300px',
                                maxWidth: '500px',
								minWidth: '300px'
                            }
                        }}
                    >
						<Search
							variant="standard"
							onChange={(e) => this.handleChange(e.target.value)}
							defaultValue={this.state.pattern}
							onKeyDown={(e) => e.stopPropagation()}
						/>
                        {this.entities.map((item, index) =>
							<MenuItem key={index}
								to={`/table/${item.id}`}
								component={Link}
								selected={item.id === this.props.tableId}
								onClick={this.handleClose}
							>
								<span className={"entity-icon-medium entity-icon-" + item.icon} />
								<Typography variant='inherit' noWrap>
									{item.singular}
								</Typography>
							</MenuItem>
                        )}
                    </Menu>
                }
            </Container>
        )
    }
}

export default Navigation
